/* unplugin-vue-components disabled */import script from "./MyHotArticle.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyHotArticle.vue?vue&type=script&setup=true&lang=ts"

import "./MyHotArticle.vue?vue&type=style&index=0&id=9e6e8ec0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e6e8ec0"]])

export default __exports__